import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from './service/auth.service';
import {AccountService} from './service/account.service';
import {SubscriptionService} from './service/subscription.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'angular-public';
  showApiKeyModal = false;
  apiKeyInput = '';
  validating = false;
  keyError = '';
  showKey = false;

  constructor(
    public authService: AuthService,
    public accountService: AccountService,
    private subscriptionService: SubscriptionService,
    private router: Router,
  ) {
  }


  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.accountService.fetchAccount().subscribe({error: () => {}});
    }
  }

  validateAndSaveKey(): void {
    const key = this.apiKeyInput.trim();
    if (!key) return;

    if (key === this.authService.getFrontendKey()) {
      this.keyError = 'Invalid API key';
      return;
    }

    this.validating = true;
    this.keyError = '';

    this.accountService.fetchAccount(key).subscribe({
      next: () => {
        this.authService.setApiKey(key);
        this.showApiKeyModal = false;
        this.apiKeyInput = '';
        this.validating = false;
        this.subscriptionService.triggerRefresh();
      },
      error: () => {
        this.validating = false;
        this.keyError = 'Invalid API key';
      }
    });
  }

  openChangeKeyModal(): void {
    this.apiKeyInput = this.authService.isAuthenticated() ? this.authService.getApiKey() : '';
    this.keyError = '';
    this.showKey = false;
    this.showApiKeyModal = true;
  }

  clearApiKey(): void {
    this.authService.clearApiKey();
    this.accountService.clear();
    this.apiKeyInput = '';
    this.keyError = '';
    this.showApiKeyModal = false;
    this.subscriptionService.triggerRefresh();
    // Leave any key-gated page (e.g. settings) and return to the homepage.
    this.router.navigate(['/home']);
  }
}